import { ChartModel } from '../../model/chart-model';
import { Coordinate } from '../../model/coordinate';
import { Series } from '../../model/series';
import { LineStyle } from '../../renderers/draw-line';
import { IPaneRenderer } from '../../renderers/ipane-renderer';

import { IPaneView } from './ipane-view';
import { ExtendedType } from '../../model/simple-line-options';
import { SimpleLineRendererData, SimpleLineRenderer } from '../../renderers/simple-line-renderer';

export abstract class SeriesSimpleLinePaneView implements IPaneView {
	protected readonly _lineRendererData: SimpleLineRendererData = {
		width: 0,
		height: 0,
		x1: 0 as Coordinate,
		y1: 0 as Coordinate,
		x2: 0 as Coordinate,
		y2: 0 as Coordinate,
		extended: ExtendedType.NoExtended,
		color: 'rgba(0, 0, 0, 0)',
		lineWidth: 1,
		lineStyle: LineStyle.Solid,
		visible: false,
	};

	protected readonly _series: Series;
	protected readonly _model: ChartModel;
	protected readonly _lineRenderer: SimpleLineRenderer = new SimpleLineRenderer();
	private _invalidated: boolean = true;

	protected constructor(series: Series) {
		this._series = series;
		this._model = series.model();
		this._lineRenderer.setData(this._lineRendererData);
	}

	public update(): void {
		this._invalidated = true;
	}

	public renderer(height: number, width: number): IPaneRenderer {
		if (this._invalidated) {
			this._updateImpl(height, width);
			this._invalidated = false;
		}

		return this._lineRenderer;
	}

	protected abstract _updateImpl(height: number, width: number): void;
}
